"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M13.71 9.29l-6-6a1.003 1.003 0 00-1.42 1.42l5.3 5.29-5.29 5.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l6-6c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"];
//# sourceMappingURL=chevron-right.js.map